import { featureCollection, point } from '@turf/helpers'

import PoziAPIData from 'api/data'

// v6.2 DEPRECATED July 2025 - Remove function once it is clear that it will no longer be needed
const getGeoJSONFromLngLat_v6_2 = async (lng, lat) => {
  const url = 'https://reverse.geocoder.cit.api.here.com/6.2/reversegeocode.json?prox=' + lat + ',' + lng + ',100&mode=retrieveAddresses&gen=8&app_id=pYZXmzEqjmR2DG66DRIr&app_code=T-Z-VT6e6I7IXGuqBfF_vQ'
  return getGeoJSON(url)
}

const getGeoJSONFromLngLat = async (lng, lat) => {
  const url = 'https://geocode.search.hereapi.com/v1/revgeocode?apikey=SVecrrWpSGFy305AY8mMipkVXr01S7gC6yM1Lh7Qn0Y&types=address&at=' + lat + ',' + lng
  return getGeoJSON(url)
}

const getGeoJSON = async (url) => {
  if (!url) throw new Error('Invalid url.')

  console.log('PoziHereAddress url', url)

  return new Promise((resolve, reject) => {
    PoziAPIData().ajax({
      url,
      error: err => {
        console.log('PoziHereAddress ajax error: ', err)
        reject(err)
      },
      success: async hereMapsData => {
        try {
          const geojson = await convertToGeoJSON(hereMapsData)
          resolve(geojson)
        } catch (err) {
          console.log('PoziHereAddress parse error: ', err)
          reject(err)
        }
      }
    })
  })
}

/**
 * Converts Here Maps data to GeoJSON format.
 *
 * @deprecated v6.2 DEPRECATED July 2025 - Remove function once it is clear that it will no longer be needed
 * Use the updated convertToGeoJSON function instead.
 *
 * @param {object} hereMapsData - The data object from Here Maps API.
 * @returns {object} - A GeoJSON FeatureCollection object.
 */
const convertToGeoJSON_v6_2 = async (hereMapsData) => {
  if (!hereMapsData) throw new Error('Invalid hereMapsData object.')

  const features = []
  const fc = featureCollection(features)

  const results = hereMapsData?.Response?.View?.[0]?.Result ?? []

  if (results.length === 0) {
    console.log('No features found.')
    return fc
  }

  // Take the top result
  const result = results[0]

  const properties = result?.Location?.Address ? { ...result.Location.Address } : {}
  delete properties.AdditionalData
  properties['marker-symbol'] = 'default'

  const lngValue = result?.Location?.DisplayPosition?.Longitude ?? 0
  const latValue = result?.Location?.DisplayPosition?.Latitude ?? 0

  features.push(point([Number(lngValue), Number(latValue)], properties))

  return fc
}

const convertToGeoJSON = async (hereMapsData) => {
  if (!hereMapsData) throw new Error('Invalid hereMapsData object.')

  const features = []
  const fc = featureCollection(features)

  if (hereMapsData.items.length === 0) {
    console.log('No features found.')
    return fc
  }

  // Take the top result
  const result = hereMapsData.items[0]

  const properties = result?.address
    ? {
      label: result.address.label,
      houseNumber: result.address.houseNumber,
      street: result.address.street,
      locality: result.address.district,
      city: result.address.city,
      state: result.address.state,
      postcode: result.address.postalCode
    }
    : {}
  delete properties.countryCode
  delete properties.countryName

  properties['marker-symbol'] = 'default'

  const lngValue = result?.position?.lng ?? 0
  const latValue = result?.position?.lat ?? 0

  features.push(point([Number(lngValue), Number(latValue)], properties))

  return fc
}

const GetAddressFromHereMaps = () => ({
  getGeoJSON,
  getGeoJSONFromLngLat
})

export default GetAddressFromHereMaps
